<template>
    <div class="speed-data-section">
        <el-card shadow="hover">
            <div class="section-title">四、综合分析与评估：</div>
            <div style="margin-bottom: 10px;display: flex;align-items: center;">
                <span>1、怠速时间占发动机运行时间的百分比为</span>
                <span style="margin-left: 50px;">30%</span>
            </div>
            <div style="margin-bottom: 10px;display: flex;align-items: center;">
                <span>2、发动机经济转速区占工作区的百分比为</span>
                <span style="margin-left: 50px;">30%</span>
            </div>
            <div style="margin-bottom: 10px;display: flex;align-items: center;">
                <div style="flex:1;display: flex;align-items: center;"> <span>3、该统计路段平均油耗</span>
                    <span style="margin-left: 50px;">30%</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;"> <span>平均车速</span>
                    <span style="margin-left: 50px;">30%</span>
                </div>
            </div>
            <div style="margin-bottom: 10px;display: flex;align-items: center;">
                <div style="flex:1;display: flex;align-items: center;"> <span>4、车辆冷却水温度在70-105℃运行时长为</span>
                    <span style="margin-left: 50px;">30%</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;"> <span>所占百分比是</span>
                    <span style="margin-left: 50px;">30%</span>
                </div>
            </div>
            <div style="margin-bottom: 10px;display: flex;align-items: center;">
                <div style="flex:1;display: flex;align-items: center;"> <span>整个运行过程中最低温度为</span>
                    <span style="margin-left: 50px;">30%</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;"> <span>最高温度为</span>
                    <span style="margin-left: 50px;">30%</span>
                </div>
            </div>
            <div style="margin-bottom: 10px;display: flex;align-items: center;">
                <div style="flex:1;display: flex;align-items: center;"> <span>5、整个运行过程中在100-700kPa运行时长为</span>
                    <span style="margin-left: 50px;">30%</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;"> <span>所占百分比是</span>
                    <span style="margin-left: 50px;">30%</span>
                </div>
            </div>
            <div style="margin-bottom: 10px;display: flex;align-items: center;">
                <div style="flex:1;display: flex;align-items: center;"> <span>整个运行过程中最低压力</span>
                    <span style="margin-left: 50px;">30%</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;"> <span>最高压力</span>
                    <span style="margin-left: 50px;">30%</span>
                </div>
            </div>

            <div style="margin-bottom: 10px;display: flex;align-items: center;">
                <div style="flex:1;display: flex;align-items: center;"> <span>6、车辆中冷器温度在35-70℃运行时长为</span>
                    <span style="margin-left: 50px;">30%</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;"> <span>所占百分比是</span>
                    <span style="margin-left: 50px;">30%</span>
                </div>
            </div>
            <div style="margin-bottom: 10px;display: flex;align-items: center;">
                <div style="flex:1;display: flex;align-items: center;"> <span>整个运行过程中最低温度为</span>
                    <span style="margin-left: 50px;">30%</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;"> <span>最高温度为</span>
                    <span style="margin-left: 50px;">30%</span>
                </div>
            </div>

            <div style="margin-bottom: 10px;display: flex;align-items: center;">
                <div style="flex:1;display: flex;align-items: center;"> <span>7、蓄电池电压在24-28.8V的运行时长为</span>
                    <span style="margin-left: 50px;">30%</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;"> <span>所占百分比是</span>
                    <span style="margin-left: 50px;">30%</span>
                </div>
            </div>
            <div style="margin-bottom: 10px;display: flex;align-items: center;">
                <div style="flex:1;display: flex;align-items: center;"> <span>整个运行过程中最低电压</span>
                    <span style="margin-left: 50px;">30%</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;"> <span>最高电压</span>
                    <span style="margin-left: 50px;">30%</span>
                </div>
            </div>
            <div style="margin-bottom: 10px;display: flex;align-items: center;">
                <span>8、制动片磨损报警</span>
                <el-radio-group size="mini" disabled v-model="form.brakeWarn" style="margin-left: 50px;">
                    <el-radio label="无">无（正常）</el-radio>
                    <el-radio label="有">有（异常，应及时更换）</el-radio>
                </el-radio-group>
            </div>
            <div style="margin-bottom: 10px;display: flex;align-items: center;">
                <span>9、空滤器堵塞报警</span>
                <el-radio-group size="mini" disabled v-model="form.filterWarn" style="margin-left: 50px;">
                    <el-radio label="无">无（正常）</el-radio>
                    <el-radio label="有">有（异常，应及时更换）</el-radio>
                </el-radio-group>
            </div>
            <div style="margin-bottom: 10px;">
                <span>10、本时间段：</span><br />
                <el-checkbox size="mini" disabled v-model="form.operation.good">未见有不良驾驶操作行为，希望保持和发扬；</el-checkbox><br />
                <el-checkbox size="mini" disabled v-model="form.operation.bad">有个别不良驾驶操作行为</el-checkbox><br />
                <div class="op-detail" style="margin-top: 10px; margin-left: 20px;">
                    <el-checkbox size="mini" disabled v-model="form.operation.detail.speed">超速行车</el-checkbox>
                    <el-checkbox size="mini" disabled v-model="form.operation.detail.overtake">超车行车</el-checkbox>
                    <el-checkbox size="mini" disabled v-model="form.operation.detail.accel" checked>急加速</el-checkbox>
                    <el-checkbox size="mini" disabled v-model="form.operation.detail.decel" checked>急减速</el-checkbox>
                    <el-checkbox size="mini" disabled v-model="form.operation.detail.idle" checked>过长怠速</el-checkbox>
                    <el-checkbox size="mini" disabled v-model="form.operation.detail.neutral" checked>空档滑行</el-checkbox>
                    <el-checkbox size="mini" disabled v-model="form.operation.detail.ac">怠速开空调</el-checkbox>
                </div>
            </div>
            <div style="margin-bottom: 10px;">
                <span>11、司机得分：</span><br />
                <span>根据对该车在此时间段采集的数据进行分析后总体评价得分：67.36分（仅供参考）</span><br />
                <el-radio-group size="mini" disabled v-model="form.scoreLevel" style="margin-top: 10px;">
                    <el-radio label="优">优（85-100）</el-radio>
                    <el-radio label="良" checked>良（65-85）</el-radio>
                    <el-radio label="一般">一般（50-65）</el-radio>
                    <el-radio label="差">差（0-50）</el-radio>
                </el-radio-group>
            </div>
            <div style="border: 1px solid #ccc; padding: 10px;height: 200px;">
                评审结论
            </div>
            <div style="border: 1px solid #ccc; padding: 10px;height: 160px;position: relative;">
                <div style="position: absolute;left: 0; bottom: 0;right: 0;text-align: right;">
                    <el-row style="margin-right: 20px;">
                        <el-col :span="12">
                            <p style="margin-right: 84px;    margin-bottom: 20px;"> 报告人：</p>
                            <p style="margin-bottom: 20px;">年 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 月 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 日</p>
                        </el-col>
                        <el-col :span="12">
                            <p style="margin-right: 84px;    margin-bottom: 20px;">审批：</p>
                            <p style="margin-bottom: 20px;">年 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 月 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 日</p>
                        </el-col>
                    </el-row>
                </div>

            </div>
        </el-card>
    </div>
</template>

<script>

export default {
    name: "barchart",

    data() {
        return {
            form: {
                // 8-9项
                brakeWarn: '无',
                filterWarn: '无',
                // 10项：驾驶操作
                operation: {
                    good: false,
                    bad: true,
                    detail: {
                        speed: false,
                        overtake: false,
                        accel: true,
                        decel: true,
                        idle: true,
                        neutral: true,
                        ac: false
                    }
                },
                // 11项：得分等级
                scoreLevel: '良'
            }
        };
    },
    mounted() {

    },
    methods: {

    }
};
</script>
<style scoped>
.section-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
}

.op-group {
    margin-bottom: 5px;
}

.op-detail {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

.el-radio,
.el-checkbox {
    margin-right: 20px;
}

::v-deep .el-radio__input.is-disabled + span.el-radio__label {
    color: #303133 !important;
}
::v-deep .el-checkbox__input.is-disabled + span.el-checkbox__label {
    color: #303133 !important;
}
</style>